import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 3.923v7.614A11.91 11.91 0 0 0 9.882 22.65l1.041.4a3 3 0 0 0 2.154 0l1.041-.4a11.91 11.91 0 0 0 7.632-11.113V3.923a1.49 1.49 0 0 0-.868-1.362A21.7 21.7 0 0 0 12 .75a21.7 21.7 0 0 0-8.882 1.811 1.49 1.49 0 0 0-.868 1.362"
    }, null, -1)
  ]));
}
const basicShapeShield = { render };
export {
  basicShapeShield as default,
  render
};
//# sourceMappingURL=basic-shape-shield.svg.js.map
